import { useEffect, useState } from 'react'
import { getUrl, httpClient } from '../providers/data'

interface ApiGetState<T> {
  data?: T
  loading: boolean
  error: boolean
}

// GET on a custom (non react-admin) endpoint, e.g. '/organization/apps'.
// Reuses httpClient so the token and org override header are added.
export const useApiGet = <T,>(path: string): ApiGetState<T> => {
  const [state, setState] = useState<ApiGetState<T>>({ loading: true, error: false })

  useEffect(() => {
    let active = true
    setState({ loading: true, error: false })
    httpClient(`${getUrl()}${path}`, { method: 'GET' })
      .then(({ json }) => {
        if (active) setState({ data: json as T, loading: false, error: false })
      })
      .catch(() => {
        if (active) setState({ loading: false, error: true })
      })
    return () => {
      active = false
    }
  }, [path])

  return state
}
